// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_E383V","title-img":"title-img_8WoFS"};